import styled from 'styled-components';

const Container1 = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 16px;
`;
const GreyBox = styled.div`
  height: ${(props) => props.h}px;
  width: ${(props) => props.h}px;
  background-color: #f0f0f0;
  border-radius: ${(props) => props.br * 4}px;
  min-width: 160px;
  margin-bottom: 16px;
`;

const Container2 = styled.div``;

function HomeContainerLoader({ n = 6 }) {
  const numberOfCareCards = n;
  const boxes = Array.from({ length: numberOfCareCards }, (_, index) => (
    <GreyBox h={160} w={160} br={3} style={{ width: '48%' }} />
  ));
  return (
    <div
      className="w-[100%] flex flex-col  overflow-auto"
      style={{ height: 'fit-content' }}
    >
      <div className="p-4">
        <GreyBox h={20} w={160} br={1} style={{ width: '30%' }} />
        <Container1>{boxes}</Container1>
      </div>
      <GreyBox h={6} w={160} br={1} style={{ width: '100%' }} />
      <div className="p-4">
        <GreyBox h={20} w={160} br={1} style={{ width: '30%' }} />
        <GreyBox h={160} w={160} br={3} style={{ width: '100%' }} />
        <GreyBox h={20} w={160} br={1} style={{ width: '30%' }} />
        <GreyBox h={160} w={160} br={3} style={{ width: '100%' }} />
      </div>
    </div>
  );
}

export default HomeContainerLoader;
